import React, { Component } from 'react'
import Button from '~/Common-Objects/UI/Forms/Button/Button'
import Icons from '~/Common-Objects/UI/Icons/index'
import NewFeatureFeedback from '~/Common-Objects/NewFeatureFeedback'
import SquareChip from '~/Common-Objects/UI/Chips/SquareChip.jsx'
import TierLimitHolder from '~/Common-Objects/UI/Cards/TierLimitHolder'
import UpsellModal from '~/Common-Objects/UpsellModal'
import { connect } from 'react-redux'
import i18n from '~/i18n'
import AutomationSteps from '~/Common-Objects/Automations/automationSteps'
import axios from '~/data/http/axios'
import { alterFullpage } from '~/data/actions/siteActions'

@connect((store) => {
    return { account: store.accountMaster, site: store.siteMaster }
})
class AddStepDrawer extends Component {
    constructor(props) {
        super(props)
        this.state = {
            moveChildren: false,
            content: undefined,
            chosenType: '',
            newFeatureSelected: ''
        }

        this.chooseStepType = this.chooseStepType.bind(this)
    }
    chooseStepType(type, secondary) {
        if (type === 'condition' && !this.props.conditionPermission.allowed) {
            return this.setState({
                content: (
                    <div>
                        <SquareChip
                            className='mar-b25'
                            iconLeft={<Icons icon='arrowLeft' />}
                            onClick={() => this.setState({ content: undefined })}
                        >
                            Go Back
                        </SquareChip>
                        <TierLimitHolder
                            type='Condition Step'
                            err={this.props.conditionPermission.err}
                            allowedNumber={this.props.conditionPermission.allowedNumber}
                            tierName={this.props.conditionPermission.tierName}
                            onUpgrade={() => {
                                this.props.save().then(() => {
                                    this.setState({ content: undefined })
                                    this.props.history.push('/cp/company/subscription')
                                })
                            }}
                        />
                    </div>
                )
            })
        }
        if ((type == 'condition' || type == 'split') && this.props.parentStep[this.props.dataId + 1] && !secondary) {
            return this.setState({ chosenType: type, moveChildren: true })
        }

        if (type === 'sms' && !this.props.account.accountMaster.SmsAccountBillingId) {
            // they dont have an sms subscription so show the upsell
            return axios.get('/accountMaster/plan?type=2').then((res) => {
                const modal = (
                    <UpsellModal
                        inline={true}
                        plans={res.data.Plans}
                        feature={'sms'}
                        onUpgrade={() => {
                            this.props.dispatch(alterFullpage(null))
                        }}
                    />
                )
                this.props.dispatch(alterFullpage(modal))
            })
        }

        this.props.chosenStepType(type, this.props.parentStep, this.props.dataId, secondary)
    }

    render() {
        if (this.state.newFeatureSelected) {
            return (
                <NewFeatureFeedback
                    featureType='automationStepType'
                    featureSubType={this.state.newFeatureSelected}
                    closeDrawer={() => this.setState({ newFeatureSelected: '' })}
                    hideCloseCross={true}
                />
            )
        }
        if (this.state.content) return this.state.content

        if (this.state.moveChildren) {
            return (
                <div>
                    <h4 className='mar-b25'>{i18n.t('automation:add.addStep.move')}</h4>
                    <div className='mar-b25'>{i18n.t('automation:add.addStep.moveSub')}</div>
                    <div className='quickFlex'>
                        <Button
                            text={i18n.t('automation:add.addStep.moveYes')}
                            className='button-primary mar-r10'
                            onClick={() => {
                                this.chooseStepType(this.state.chosenType, 'yes')
                            }}
                        />
                        <Button
                            text={i18n.t('automation:add.addStep.moveNo')}
                            onClick={() => {
                                this.chooseStepType(this.state.chosenType, 'no')
                            }}
                        />
                    </div>
                </div>
            )
        }

        var pipedrive = this.props.applications.find((a) => a.Application.appName === 'Pipedrive')
        let generic = this.props.applications.filter(
            (a) =>
                a.Application.options.hooks &&
                a.Application.options.hooks.length &&
                a.Application.options.hooks.some((h) => h.automationaction)
        )

        if (this.props.themeapp) {
            if (
                this.props.themeapp.options &&
                this.props.themeapp.options.hooks &&
                this.props.themeapp.options.hooks.length &&
                this.props.themeapp.options.hooks.some((h) => h.automationaction)
            ) {
                generic = [{ ApplicationId: this.props.themeapp.id, Application: this.props.themeapp }]
            } else {
                generic = []
            }
        }

        var hasStepsAfter = false
        if (this.props.parentStep[this.props.dataId + 1]) {
            hasStepsAfter = true
        }

        return (
            <div>
                <h4 className='mar-b5'>{i18n.t('automation:add.addStep.add')}</h4>
                <div className='mar-b25'>{i18n.t('automation:add.addStep.addSub')}</div>

                <AutomationSteps.Group title={'Actions'}>
                    <AutomationSteps.Step
                        icon={<Icons icon='envelope' circle={true} />}
                        onClick={() => {
                            this.chooseStepType('email')
                        }}
                        title={i18n.t('automation:add.addStep.email')}
                        subTitle={i18n.t('automation:add.addStep.emailSub')}
                    />
                    {this.props.site.siteId === 1 && (
                        <AutomationSteps.Step
                            icon={<Icons icon='sms' circle={true} />}
                            onClick={() => {
                                this.chooseStepType('sms')
                            }}
                            title={i18n.t('automation:add.addStep.sms')}
                            subTitle={i18n.t('automation:add.addStep.smsSub')}
                        />
                    )}
                    <AutomationSteps.Step
                        icon={<Icons icon='person' circle={true} />}
                        onClick={() => {
                            this.chooseStepType('action')
                        }}
                        title={i18n.t('automation:add.addStep.action')}
                        subTitle={i18n.t('automation:add.addStep.actionSub')}
                    />
                    <AutomationSteps.Step
                        icon={<Icons icon='megaphone' circle={true} />}
                        onClick={() => {
                            this.chooseStepType('notification')
                        }}
                        title={i18n.t('automation:add.addStep.notification')}
                        subTitle={i18n.t('automation:add.addStep.notificationSub')}
                    />
                    <AutomationSteps.Step
                        icon={<Icons icon='arrowsUpDown' circle={true} />}
                        onClick={() => {
                            this.chooseStepType('score')
                        }}
                        title={i18n.t('automation:add.condition.scoreScore')}
                        subTitle={i18n.t('automation:add.condition.scoreDetail')}
                    />
                    <AutomationSteps.Step
                        icon={<Icons icon='medal' circle={true} />}
                        onClick={() => {
                            this.chooseStepType('goal')
                        }}
                        title={i18n.t('automation:add.addStep.goal')}
                        subTitle={i18n.t('automation:add.addStep.goalSub')}
                    />
                    <AutomationSteps.Step
                        icon={<Icons icon='external' circle={true} />}
                        onClick={() => {
                            this.chooseStepType('webhook')
                        }}
                        title={i18n.t('automation:add.addStep.webhook')}
                        subTitle={i18n.t('automation:add.addStep.webhookSub')}
                    />
                    <AutomationSteps.Step
                        icon={<Icons icon='arrowBounce' circle={true} />}
                        onClick={() => {
                            if (!hasStepsAfter) {
                                this.chooseStepType('redirect')
                            }
                        }}
                        title={i18n.t('automation:add.addStep.redirect')}
                        subTitle={i18n.t('automation:add.addStep.redirectSub')}
                        disabled={hasStepsAfter}
                        alt={hasStepsAfter ? i18n.t('automation:add.addStep.redirectWarning') : ''}
                    />
                </AutomationSteps.Group>
                <AutomationSteps.Group title={'Conditions'}>
                    <AutomationSteps.Step
                        icon={<Icons icon='branchDown' circle={true} />}
                        onClick={() => this.chooseStepType('condition')}
                        title={i18n.t('automation:add.addStep.condition')}
                        subTitle={i18n.t('automation:add.addStep.conditionSub')}
                    />
                    <AutomationSteps.Step
                        icon={<Icons icon='clock' circle={true} />}
                        onClick={() => {
                            this.chooseStepType('delay')
                        }}
                        title={i18n.t('automation:add.addStep.delay')}
                        subTitle={i18n.t('automation:add.addStep.delaySub')}
                    />
                    <AutomationSteps.Step
                        icon={<Icons icon='download' circle={true} />}
                        onClick={() => {
                            this.chooseStepType('wait')
                        }}
                        title={i18n.t('automation:add.addStep.wait')}
                        subTitle={i18n.t('automation:add.addStep.waitSub')}
                    />
                    <AutomationSteps.Step
                        icon={<Icons icon='transaction' circle={true} />}
                        onClick={() => {
                            this.chooseStepType('split')
                        }}
                        title={i18n.t('automation:add.addStep.split')}
                        subTitle={i18n.t('automation:add.addStep.splitSub')}
                    />
                </AutomationSteps.Group>

                {generic.map((app, appIndex) => {
                    return (
                        <AutomationSteps.Group title={app.Application.appName} key={app.Application.appName + appIndex}>
                            {app.Application.options.hooks
                                .filter((h) => h.automationaction)
                                .map((hook, hookIndex) => {
                                    console.log(hook)
                                    try {
                                        let triggers = this.props.trigger.stepOptions.trigger
                                            ? [this.props.trigger.stepOptions.trigger.value]
                                            : []
                                        if (this.props.trigger.triggerSteps && this.props.trigger.triggerSteps.length) {
                                            triggers.push(
                                                ...this.props.trigger.triggerSteps
                                                    .filter((s) => s.triggerType.value === app.Application.appName)
                                                    .map((s) => s.stepOptions.trigger.value)
                                            )
                                        }
                                        if (
                                            hook.triggerFilter &&
                                            Array.isArray(hook.triggerFilter) &&
                                            hook.triggerFilter.length
                                        ) {
                                            if (!triggers.some((t) => hook.triggerFilter.indexOf(t.value || t) > -1))
                                                return null
                                        }
                                    } catch (e) {}

                                    return (
                                        <AutomationSteps.Step
                                            key={app.Application.appName + hookIndex}
                                            icon={<img src={app.Application.appLogoUri} height='30' />}
                                            onClick={() => this.chooseStepType(app.ApplicationId, hookIndex)}
                                            title={hook.name}
                                            subTitle={`${hook.name} on ${app.Application.appName}`}
                                        />
                                    )
                                })}
                        </AutomationSteps.Group>
                    )
                })}
            </div>
        )
    }
}

export default AddStepDrawer
